/**
 * Created by Victor Rojo on 15/3/18.
 */
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[OnlyNumber]'
})
export class OnlyNumber {

    constructor(private el: ElementRef) { }

    @Input() OnlyNumber: string;
    private allowedIntegerKeys = [8,9,13,35,36,37,38,39,40,46,48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105];
    private allowedFloatKeys = [8,9,13,35,36,37,38,39,40,46,48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105,110,190];

    @HostListener('keydown', ['$event']) onKeyDown(event:any) {
        let e = <KeyboardEvent> event;
        if ( this.OnlyNumber == "integer" ) {
            if ( this.allowedIntegerKeys.indexOf(e.keyCode) != -1 ||
                    // Allow: Ctrl+A
                (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) ||
                    // Allow: Ctrl+C
                (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) ||
                    // Allow: Ctrl+X
                (e.keyCode == 88 && (e.ctrlKey || e.metaKey))) {
                return;
            } else {
                e.preventDefault();
            }
        } else if ( this.OnlyNumber == "float" ){
            if ( this.allowedFloatKeys.indexOf(e.keyCode) != -1 ||
                    // Allow: Ctrl+A
                (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) ||
                    // Allow: Ctrl+C
                (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) ||
                    // Allow: Ctrl+X
                (e.keyCode == 88 && (e.ctrlKey || e.metaKey))) {
                return;
            } else {
                e.preventDefault();
            }
        }
    }
}